export default "__VITE_ASSET__CcVmU9Gg__"